import React, { useRef, useContext, useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Img from "gatsby-image"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { motion, useAnimation } from "framer-motion"

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const specializationsItems = require('../../config/refs/specializations-candidates.json')

import { language } from "config"
import { CircularProgress } from "@mui/material"

const types = [
  "candidat",
  "client"
]

const employmentTypes = [
  "permanent",
  "consultance",
]

const specializations = specializationsItems.map(item => item.label)

const StyledGrid = styled(Grid)`
  .MuiInputBase-root {
    background: white;
    fieldset {
      border-color: #D9DDE1;
    }
  }
`

const StyledFormAction =  styled.div`
  margin-top: 2rem;
  display: flex; 
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const StyledButton = styled(Button)`
  &.MuiButton-root {
    background-color: #E0690F;
    font-size: 0.94112rem;
    line-height: 1.264rem;
    padding: 0.9rem 2rem;
    border-radius: 0.5882rem;
    width: 100%;
    i {
      line-height: inherit;
    }
    &.MuiButton-outlined {
      margin-top: 1rem;
      background-color: unset;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: unset;
      min-width: 14rem;
      &.MuiButton-outlined {
        margin-right: 1rem;
        margin-top: 0;
      }
    }
    &:hover {
      background-color: #E0690F;
      opacity: 0.9;
    }
  }
`

  const SuccessMessageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e6f7e6;
    border: 1px solid #b3ddb3;
    border-radius: 8px;
    padding: 16px;
    margin: 20px 0;
    color: #3c763d;
    font-family: Arial, sans-serif;
  `;

  const IconWrapper = styled.div`
    margin-right: 10px;
    font-size: 24px;
    color: #3c763d;
  `;

  const MessageText = styled.div`
    font-size: 16px;
    font-weight: 500;
  `;

const ContactForm = ({  }) => {
    const [firstName, setFirstName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [email, setEmail] =  React.useState('');
    const [phone, setPhone] =  React.useState('');
    const [type, setType] = React.useState('candidat');
    const [employmentType, setEmploymentType] = React.useState('permanent');
    const [specialization, setSpecialization] = React.useState("");
    const [enterprise, setEnterprise] = React.useState("");
    const [functionName, setFunctionName] = React.useState("");
    const [message, setMessage] =  React.useState("");
    const [file, setFile] = React.useState(null);
    const [errors, setErrors] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [submitSuccess, setSubmitSuccess] = React.useState(false);

    const validateEmail = (email) => {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const validatePhone = (phone) => {
      return String(phone).match(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/);
    };

    const handleInputChange = () => {
      setSubmitSuccess(false);
    };

    const handleSubmit = async (event) => {
      event.preventDefault();
      setSubmitSuccess(false);
      const newErrors = {};

      if (!firstName) newErrors.firstName = "First name is required";
      if (!lastName) newErrors.lastName = "Last name is required";
      if (!email) newErrors.email = "Email is required";
      else if (!validateEmail(email)) newErrors.email = "Invalid email format";
      if (!phone) newErrors.phone = "Phone is required";
      else if (!validatePhone(phone)) newErrors.phone = "Invalid phone format";
      if (!message) newErrors.message = "Message is required";

      if (type === 'candidat') {
        if (!specialization) newErrors.specialization = "Specialization is required";
        if (!file) newErrors.file = "Resume is required";
      }

      if (type === 'client') {
        if (!enterprise) newErrors.enterprise = "Enterprise is required";
        if (!functionName) newErrors.functionName = "Function name is required";
      }

      setErrors(newErrors);

      if (Object.keys(newErrors).length === 0) {
        setLoading(true)
        const formData = new FormData();
        formData.append('type', type);
        formData.append('type_service', employmentType);
        formData.append('first_name', firstName);
        formData.append('last_name', lastName);
        formData.append('email', email);
        formData.append('entreprise', enterprise);
        formData.append('fonction', functionName);
        formData.append('phone', phone);
        formData.append('specialization', specialization);
        formData.append('message', message);

        
        if (file) {
          formData.append('resume', file);
        }
  
        try {
        const response = await fetch('https://api-workflows.hrflow.ai/teams/0ac495eda8ac4e8cee4ea1867c9c6021fabc25c5/manpower-be/python3.9/d8b1e5884e7967d7a923d613da0711b2a205f1df', {
             method: 'POST',
             body: formData
           });
           const data = await response.json();
           console.log(data)
           setLoading(false)
           setSubmitSuccess(true);
         } catch (error) {
           console.error('Error:', error);
           setLoading(false)
         }
      }
     
    };

    const handleChangeType = (event) => {
      const {
        target: { value },
      } = event;
      setType(value);
      setErrors({});
      handleInputChange();
    };

    const handleChangeEmplymentType = (event) => {
      const {
        target: { value },
      } = event;
      setEmploymentType(value);
      handleInputChange();
    };

    const handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result.split(',')[1];
          setFile(base64String);
        };
        reader.readAsDataURL(file);
      }
      handleInputChange();
    };

    return (
        <form onSubmit={handleSubmit}>
            <StyledGrid
              container
              spacing={2}
              sx={{
                marginTop: '2rem'   
              }}
            >
              <Grid item  xs={12} sm={6} >
                <FormControl sx={{width: '100%'}} error={!!errors.firstName}>
                  <Typography gutterBottom  component="label">
                    {language.contact_fname} *
                  </Typography>
                  <TextField
                    margin="dense"
                    id="lname"
                    type="text"
                    fullWidth
                    sx={{marginBottom: '0'}}
                    size="small"
                    placeholder={language.contact_fname}
                    value={firstName}
                    onChange={event => {
                      setFirstName(event.target.value);
                      handleInputChange();
                    }}
                    error={!!errors.firstName}
                  />
                  {errors.firstName && <FormHelperText>{errors.firstName}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item  xs={12} sm={6} >
                <FormControl sx={{width: '100%'}} error={!!errors.lastName}>
                  <Typography gutterBottom  component="label">
                  {language.contact_lname} *
                  </Typography>
                  <TextField
                    margin="dense"
                    id="fname"
                    type="text"
                    fullWidth
                    sx={{marginBottom: '0'}}
                    size="small"
                    placeholder={language.contact_lname}
                    value={lastName}
                    onChange={event => {
                      setLastName(event.target.value);
                      handleInputChange();
                    }}
                    error={!!errors.lastName}
                  />
                  {errors.lastName && <FormHelperText>{errors.lastName}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item  xs={12} sm={6} >
                <FormControl sx={{width: '100%'}} error={!!errors.email}>
                  <Typography gutterBottom  component="label">
                  {language.contact_email} *
                  </Typography>
                  <TextField
                    margin="dense"
                    id="email"
                    type="text"
                    fullWidth
                    sx={{marginBottom: '0'}}
                    size="small"
                    placeholder={language.contact_email}
                    value={email}
                    onChange={event => {
                      setEmail(event.target.value);
                      handleInputChange();
                    }}
                    error={!!errors.email}
                  />
                  {errors.email && <FormHelperText>{errors.email}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item  xs={12} sm={6} >
                <FormControl sx={{width: '100%'}} error={!!errors.phone}>
                  <Typography gutterBottom  component="label">
                  {language.contact_phone} *
                  </Typography>
                  <TextField
                    margin="dense"
                    id="phone"
                    type="text"
                    fullWidth
                    sx={{marginBottom: '0'}}
                    size="small"
                    placeholder={language.contact_phone}
                    value={phone}
                    onChange={event => {
                      setPhone(event.target.value);
                      handleInputChange();
                    }}
                    error={!!errors.phone}
                  />
                  {errors.phone && <FormHelperText>{errors.phone}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item  xs={12} sm={6}>
                <FormControl sx={{width: '100%'}}>
                  <Typography gutterBottom  component="label">
                    {language.contact_type}
                  </Typography>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    value={type}
                    onChange={handleChangeType}
                    size="small"
                    displayEmpty
                  >
                    {types.map((type) => (
                      <MenuItem
                        key={type}
                        value={type}
                      >
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item  xs={12} sm={6}>
                <FormControl sx={{width: '100%'}}>
                  <Typography gutterBottom  component="label">
                  {language.contact_employmentType}
                  </Typography>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    value={employmentType}
                    onChange={handleChangeEmplymentType}
                    size="small"
                    displayEmpty
                  >
                    {employmentTypes.map((type) => (
                      <MenuItem
                        key={type}
                        value={type}
                      >
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {type === 'client' && (
                <>
                  <Grid item  xs={12} sm={6} >
                    <FormControl sx={{width: '100%'}} error={!!errors.enterprise}>
                      <Typography gutterBottom  component="label">
                        {language.contact_enterprise} *
                      </Typography>
                      <TextField
                        margin="dense"
                        id="enterprise"
                        type="text"
                        fullWidth
                        sx={{marginBottom: '0'}}
                        size="small"
                        placeholder={language.contact_enterprise}
                        value={enterprise}
                        onChange={event => {
                          setEnterprise(event.target.value);
                          handleInputChange();
                        }}
                        error={!!errors.enterprise}
                      />
                      {errors.enterprise && <FormHelperText>{errors.enterprise}</FormHelperText>}
                    </FormControl>
                  </Grid>
                  <Grid item  xs={12} sm={6} >
                    <FormControl sx={{width: '100%'}} error={!!errors.functionName}>
                      <Typography gutterBottom  component="label">
                        {language.contact_function} *
                      </Typography>
                      <TextField
                        margin="dense"
                        id="fonction"
                        type="text"
                        fullWidth
                        sx={{marginBottom: '0'}}
                        size="small"
                        placeholder={language.contact_function}
                        value={functionName}
                        onChange={event => {
                          setFunctionName(event.target.value);
                          handleInputChange();
                        }}
                        error={!!errors.functionName}
                      />
                      {errors.functionName && <FormHelperText>{errors.functionName}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </>
              )}
              {type === 'candidat' && (
                <>
                  <Grid item  xs={12} sm={6}>
                    <FormControl sx={{width: '100%'}} error={!!errors.specialization}>
                      <Typography gutterBottom  component="label">
                        {language.contact_spesialization} {type === 'candidat' && '*'}
                      </Typography>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        value={specialization}
                        renderValue={() => {
                          if (!specialization) {
                            return <span style={{opacity: "0.38"}}>{language.contact_spesialization}</span>;
                          }
              
                          return specialization
                        }}
                        displayEmpty
                        onChange={event => {
                          setSpecialization(event.target.value);
                          handleInputChange();
                        }}
                        size="small"
                        sx={{ marginTop: '8px'}}
                        error={!!errors.specialization}
                      >
                      <MenuItem disabled value="">
                          <span>{language.contact_spesialization} </span>
                        </MenuItem>
                        {specializations.map(c =>  <MenuItem key={c} value={c}>{c}</MenuItem>)}
                      </Select>
                      {errors.specialization && <FormHelperText>{errors.specialization}</FormHelperText>}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl sx={{width: '100%'}} error={!!errors.file}>
                      <Typography gutterBottom component="label">
                      {language.contact_resume} {type === 'candidat' && '*'}
                      </Typography>
                      <TextField
                        type="file"
                        fullWidth
                        margin="dense"
                        size="small"
                        onChange={handleFileChange}
                        error={!!errors.file}
                        InputProps={{
                          inputProps: {
                            accept: '.pdf,.doc,.docx'
                          }
                        }}
                      />
                      {errors.file && <FormHelperText>{errors.file}</FormHelperText>}
                    </FormControl>
                  </Grid>
                </>
              )}
              
              <Grid item xs={12} sm={12}>
                <FormControl sx={{width: '100%'}} error={!!errors.message}>
                  <Typography gutterBottom  component="label">
                    {language.contact_message} *
                  </Typography>
                  <TextField
                    multiline
                    rows={4}
                    fullWidth
                    margin="dense"
                    id="message"
                    type="text"
                    sx={{marginBottom: '0'}}
                    size="small"
                    placeholder={language.contact_message}
                    value={message}
                    onChange={event => setMessage(event.target.value)}
                    error={!!errors.message}
                  />
                  {errors.message && <FormHelperText>{errors.message}</FormHelperText>}
                </FormControl>
              </Grid>
            </StyledGrid>
            <StyledFormAction>
              <StyledButton type="submit" variant="contained" disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : language.contact_submit}
              </StyledButton>
            </StyledFormAction>
            {submitSuccess && (
              <SuccessMessageContainer>
                <IconWrapper>
                  <CheckCircleIcon />
                </IconWrapper>
                <MessageText>{language.contact_success}</MessageText>
              </SuccessMessageContainer>
            )}
           
        </form>
    );
}

export default ContactForm